import React from 'react';

export default () => (
  <div className="instruction-container">
    <div className="row">
      <div className="col">
        <h2 className="title">Cross-sell recommendations</h2>
        <p>
          Below shows your cross-sell recommendations, calculated using your historic order data.
          Select a recommendation below and create a cross-sell campaign in 2 clicks.
        </p>
      </div>
    </div>
  </div>
);
